export const testIds = {
  sectionTitle: 'section-title',
  unassignedMessage: 'unassigned-message',
  buttonAssign: 'button-assign',
  buttonEdit: 'button-edit',
  actionBar: 'action-bar',
  teamOrgStatus: 'team-org-status',
};
